export function formatDate(date) {
  if (!date) {
    return "";
  }
  let day = date.getDate();
  if (day < 10) day = "0" + day;
  let monthIndex = date.getMonth() + 1;
  if (monthIndex < 10) monthIndex = "0" + monthIndex;
  const year = date.getFullYear();

  return day + "/" + monthIndex + "/" + year;
}

export function fixDateFromDataBase(date) { // GMT+n to Z
  if (!date) {
    return null;
  }  
  const fixedDate = new Date(date).valueOf() + (new Date(date).getTimezoneOffset() * 60 * 1000);
  return new Date(fixedDate).toJSON();
}

export function fixDateToDataBase(date) { // Z to GMT+n
  if (!date) {
    return null;
  }  
  const fixedDate = new Date(date).valueOf() - (new Date(date).getTimezoneOffset() * 60 * 1000);
  return new Date(fixedDate).toJSON();
}